<template lang="pug">
  v-container.View.View--Ticket
    template(v-if="!loading")
      template(v-if="ticket.status=='cancelled'")
        .text-center.py-6
          .headline {{ ticket.location.name }}
          .py-6
            .font-weight-medium Questo ticket risulta annullato.
          div.py-6
            v-btn.primary(@click="$router.push({ name: 'place', params: { place:ticket.location.id } })") Prenota di nuovo
      template(v-if="ticket.status=='served'")
        .text-center.py-6
          .headline {{ ticket.location.name }}
          .py-6
            .font-weight-medium Questo ticket risulta gia' servito.
      template(v-if="ticket.status=='noshow'")
        .text-center.py-6
          .headline {{ ticket.location.name }}
          .py-6
            .font-weight-medium L'esercente non ti ha trovato quando era il tuo turno.
          div.py-6
            v-btn.primary(@click="$router.push({ name: 'place', params: { place:ticket.location.id } })") Prenota di nuovo
      template(v-if="ticket.status=='waiting'")
        .d-flex.align-center.justify-center.pa-3
          .d-flex-grow.font-weight-medium.green--text Ecco il tuo ticket digitale
        v-card
          v-card-text.pb-0
            .text-center.py-3
              .display-1 {{ ticket.location.name }}
              .subtitle-1
                | Orario stimato:
                | {{ new Date(ticket.estimatedArrivalDate).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) }}
                | del
                | {{ new Date(ticket.estimatedArrivalDate).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) }}
              .subtitle-1 Fra {{ formatWaitTime(ticket.estimatedArrivalDate) }}
              div.QRCode(v-html="ticket.qrcode" )
              .display-1 ID {{ ticket.number }}
              div  Prima di te:&nbsp;
                span.font-weight-bold {{ ticket.beforeYou }} persone
            v-divider
            .d-flex.justify-space-around
              // router-link.clean.d-inline-block.pa-3.text-center(:to='false')
                v-icon.primary--text mdi-directions
                div.primary--text Come arrivare?
              .d-inline-block.pa-3.text-center.cursor-pointer(@click="downloadQR(ticket.qrcode)")
                v-icon.primary--text mdi-qrcode
                div.primary--text Scarica QR
        .font-weight-medium.text-center.my-5.error--text Hai cambiato idea?&nbsp;
          b.cursor-pointer(@click='dialogCancelTicket=true' style="text-decoration:underline") Annulla la prenotazione

      v-dialog(v-model="dialogCancelTicket")
        v-card
          v-card-title
            div Annulla prenotazione
            v-spacer
            v-btn(icon @click="dialogCancelTicket=false")
              v-icon mdi-close
          v-card-text
            p Sei sicuro di voler annullare la prenotazione?
            template(v-if="$auth.check()")
              v-btn.error(@click="cancelTicket" :loading="loadingCancelTicket") Annulla Prenotazione
            template(v-else)
              div Inserisci la tua mail per confermare l'identità
              ValidationObserver(v-slot="{ invalid, validated, passes }")
                ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                  v-text-field(
                    v-model="cancelTicketForm.email" required
                    :error-messages="errors"
                    name="e-mail" type="email"
                    label="Email" prepend-inner-icon="mdi-at"
                  )
                div
                v-btn.error(
                  @click="cancelTicketUnauthenticated"
                  :disabled="invalid"
                  :loading="loadingCancelTicket"
                ) Annulla Prenotazione

    template(v-else)
      Loading
</template>

<script>
import Loading from "@/components/Loading";
import Ticket from "@/api/TicketPublic";
import downloadQR from "@/utils/downloadSVG";

import { formatWaitTime } from "@/utils/delayUtils";

export default {
  name: "Ticket",
  components: { Loading },

  data: () => ({
    loading: true,
    loadingReserve: false,
    ticket: null,

    dialogCancelTicket: false,
    cancelTicketForm: {},
    loadingCancelTicket: false
  }),

  async mounted() {
    this.loading = true;

    this.$emit("update:title", "La tua prenotazione");
    this.ticket = await Ticket.get(this.$route.params.ticket);

    this.loading = false;
  },

  methods: {
    formatWaitTime,
    downloadQR,

    async cancelTicket() {
      this.loadingCancelTicket = true;
      try {
        await Ticket.cancel(this.$route.params.ticket);
      } finally {
        this.loadingCancelTicket = false;
      }
      this.$router.replace({
        name: "place",
        params: { place: this.ticket.location.id }
      });
    },

    async cancelTicketUnauthenticated() {
      this.loadingCancelTicket = true;
      console.log(this.cancelTicketForm.email);
      try {
        await Ticket.cancelUnauthenticated(this.$route.params.ticket, {
          email: this.cancelTicketForm.email
        });
      } finally {
        this.loadingCancelTicket = false;
      }
      this.$router.replace({
        name: "place",
        params: { place: this.ticket.location.id }
      });
    }
  }
};
</script>
